// Components/Pages/Admin/Projects.jsx
import { useState, useEffect } from "react";
import AdminTable from "./AdminTable";
import AdminForm from "./AdminForm";
import { api } from "./api";

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingProject, setEditingProject] = useState(null);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const data = await api.getProjects();
      setProjects(data);
    } catch (error) {
      console.error('Error fetching projects:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setEditingProject(null);
    setShowForm(true);
  };

  const handleEdit = (project) => {
    setEditingProject(project);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this project?')) {
      try {
        await api.deleteProject(id);
        await fetchProjects();
      } catch (error) {
        console.error('Error deleting project:', error);
      }
    }
  };

  const handleSubmit = async (data) => {
    try {
      if (editingProject) {
        await api.updateProject(editingProject.id, data);
      } else {
        await api.createProject(data);
      }
      setShowForm(false);
      await fetchProjects();
    } catch (error) {
      console.error('Error saving project:', error);
    }
  };

  const columns = [
    { key: 'title', label: 'Title' },
    { key: 'tag', label: 'Category' },
    { key: 'donor', label: 'Donor' },
    { key: 'description', label: 'Description', render: (val) => val?.substring(0, 80) + (val?.length > 80 ? '...' : '') },
  ];

  const fields = [
    { name: 'title', label: 'Title', required: true, placeholder: 'Enter project title' },
    { name: 'tag', label: 'Category', required: true, placeholder: 'e.g., Gender Equality & Inclusion' },
    { name: 'donor', label: 'Donor', required: false, placeholder: 'e.g., Funded by WHO' },
    { name: 'description', label: 'Description', type: 'textarea', required: true, rows: 4 },
    { name: 'impact', label: 'Impact', type: 'textarea', required: false, rows: 3 },
    { name: 'image', label: 'Image URL', required: false, placeholder: 'https://example.com/image.jpg' },
  ];

  if (loading) {
    return <div className="text-center py-8">Loading...</div>;
  }

  return (
    <div>
      <AdminTable
        title="Projects"
        columns={columns}
        data={projects}
        onAdd={handleAdd}
        onEdit={handleEdit}
        onDelete={handleDelete}
        addButtonLabel="Add Project"
      />

      {showForm && (
        <AdminForm
          title="Project"
          fields={fields}
          initialData={editingProject || {}}
          onSubmit={handleSubmit}
          onCancel={() => setShowForm(false)}
          isEditing={!!editingProject}
        />
      )}
    </div>
  );
};

export default Projects;